export default "__VITE_ASSET__6f1cd46b__"